import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogOut, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { BRAND_NAME } from "@/config";
import { AdminProducts } from "@/components/admin/AdminProducts";
import { AdminCategories } from "@/components/admin/AdminCategories";

export default function AdminDashboard() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState("products");

  useEffect(() => {
    if (!loading && !user) navigate("/admin");
  }, [user, loading, navigate]);

  if (loading || !user) return null;

  return (
    <div className="min-h-screen bg-secondary" data-testid="admin-dashboard">
      <header className="sticky top-0 z-40 border-b border-border bg-white">
        <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-5 md:px-10">
          <div className="flex items-center gap-4">
            <span className="font-serif text-xl tracking-[0.15em] text-stone-900">{BRAND_NAME}</span>
            <span className="text-[10px] uppercase tracking-[0.3em] text-wine">Admin</span>
          </div>
          <div className="flex items-center gap-3">
            <Link to="/" target="_blank" rel="noreferrer" data-testid="view-site-link" className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-stone-500 hover:text-stone-900">
              View site <ArrowUpRight size={13} />
            </Link>
            <button data-testid="logout-btn" onClick={() => { logout(); navigate("/admin"); }} className="flex items-center gap-1.5 border border-border px-4 py-2 text-[11px] uppercase tracking-[0.2em] text-stone-500 hover:border-wine hover:text-wine">
              <LogOut size={13} /> Sign out
            </button>
          </div>
        </div>
        <div className="mx-auto flex max-w-[1400px] gap-8 px-5 md:px-10">
          {[["products", "Products"], ["categories", "Categories"]].map(([key, label]) => (
            <button
              key={key}
              data-testid={`tab-${key}`}
              onClick={() => setTab(key)}
              className={`-mb-px border-b-2 py-3 text-[11px] uppercase tracking-[0.2em] transition-colors ${tab === key ? "border-wine text-wine" : "border-transparent text-stone-400 hover:text-stone-700"}`}
            >
              {label}
            </button>
          ))}
        </div>
      </header>

      <main className="mx-auto max-w-[1400px] px-5 py-12 md:px-10">
        {tab === "products" ? <AdminProducts /> : <AdminCategories />}
      </main>
    </div>
  );
}
